import React, { useEffect, useState } from 'react';
import './Department.css'; // Import your custom CSS file

export default function Department() {

  const [dep, setdep] = useState([]);
  const [isloading, setisloading] = useState(false)

  useEffect(() => {
    dept();
  }, []);

  async function dept() {
    setisloading(true)
    const res = await fetch("https://payrole.onrender.com/Deptdetails", {
      method: 'POST',
      body: JSON.stringify(),
      headers: { 'Content-Type': 'application/json' }
    });

    const likedpostcreatedtime = await res.json();
    setdep(likedpostcreatedtime);

    console.log(likedpostcreatedtime)

    setisloading(false)
  }

  return (
    <div className="department-container">
      <h2 className="department-heading">Department Information</h2>



      {isloading?<>
      
      <h1>Fetching details please wait ........</h1>

      <div class="spinner-grow" role="status">
  <span class="sr-only">Loading...</span>
</div>
      
      
      
      </>:<>
      
      
      
      <div className="department-list">
        {dep.map((w) => (
          <div key={w.DepartmentName} className="department-card">
            <h3 className="department-id">{w.DepartmentName}</h3>
            <p className="department-name">{w.DepartmentID}</p>
            <p className="department-employees">{w.NumberOfEmployees} Employees</p>
          </div>
        ))}
      </div>
      
      
      
      
      
      
      
      
      
      </>}

     
    </div>
  );
}
